module.exports = __webpack_public_path__ + "img/cabbage-clean-medium.9bd77cc6.png";